import { CommonResponse } from 'models/common';
import moment from 'moment';
import { DATE_HYPHEN_FORMAT } from 'utils';
import axiosClient from 'utils/axiosClient';
import { RestaurantOption } from './models';
import { MenuBookListItem, MenuBookListRequestPayload } from './models/menuBook';

const menuBookListService = {
  getRestaurantList(dataDate: Date): Promise<CommonResponse<RestaurantOption[]>> {
    const dateDateFormat = moment(dataDate).format(DATE_HYPHEN_FORMAT);
    const url = `/restaurants?display_type=1&data_date=${dateDateFormat}`;
    return axiosClient.get(url);
  },
  getMenuBookList(params: MenuBookListRequestPayload): Promise<CommonResponse<MenuBookListItem[]>> {
    const url = `/menubooks`;
    return axiosClient.get(url, { params });
  },
};

export default menuBookListService;
